import { INSIGHTS_GRID_CLASS_NAME } from '../insight-card-width';
import { Last2WeeksVendingPackageVolumeHourDayHeatmapChart } from './last-2-weeks-vending-package-volume-hour-day-heatmap-chart.component';
import { Last2WeeksVendingReplenishmentActivityHourDayHeatmapChart } from './last-2-weeks-vending-replenishment-activity-hour-day-heatmap-chart.component';
import { Last30DaysVendingRecycleSpotFillRateLineChart } from './last-30-days-vending-recycle-spot-fill-rate-line-chart.component';
import { VendingLongestReviewWaitsList } from './vending-longest-review-waits-list.component';
import { VendingProductPopularityList } from './vending-product-popularity-list.component';
import { VendingTimeToStockoutList } from './vending-time-to-stockout-list.component';
import { VendingTopConsumersList } from './vending-top-consumers-list.component';

export interface VendingInsightsPageProps {
    accountId: string;
}

/** Standalone Vending insights content — reusable outside Analytics. */
export const VendingInsightsPage = ({ accountId }: VendingInsightsPageProps) => (
    <div className={INSIGHTS_GRID_CLASS_NAME}>
        <VendingProductPopularityList
            accountId={accountId}
            width={2}
        />
        <VendingTimeToStockoutList
            accountId={accountId}
            width={2}
        />
        <VendingTopConsumersList
            accountId={accountId}
            width={2}
        />
        <VendingLongestReviewWaitsList
            accountId={accountId}
            width={2}
        />
        <Last2WeeksVendingPackageVolumeHourDayHeatmapChart
            accountId={accountId}
            width={2}
        />
        <Last2WeeksVendingReplenishmentActivityHourDayHeatmapChart
            accountId={accountId}
            width={2}
        />
        <Last30DaysVendingRecycleSpotFillRateLineChart
            accountId={accountId}
            width={2}
        />
    </div>
);
